import { SettingsService } from '@app/core/services/settings.service';
import { FormDefinitionService } from '@app/core/services/form-definition.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { NavigationMenuComponent } from '@app/shared/components/navigation-menu/navigation-menu.component';
import { AuthService } from '@app/core/services/auth.service';
import { ContextService } from '@app/core/services/context.service';
import { Constants } from '@app/core/services/constants';
import { LanguageService } from '@app/core/services/language.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [
    IonApp, 
    IonRouterOutlet,
    NavigationMenuComponent
  ],
})
export class AppComponent implements OnInit {
  
  constructor(private authService: AuthService,
              private contextService: ContextService,
              private formDefinitionService: FormDefinitionService,
              private settingsService: SettingsService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private titleService: Title,
              private languageService: LanguageService) {
  }

  ngOnInit(): void {
    // Language service auto-initializes on construction
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.updatePageTitle());

    this.languageService.currentLanguage$.subscribe(() => this.updatePageTitle());
  }

  private updatePageTitle(): void {
    let currentRoute = this.activatedRoute;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const titleKey = currentRoute.snapshot.data['title'];
    const title = titleKey ? this.languageService.instant(titleKey) : '';
    const suffix = title && title !== titleKey ? title : titleKey || '';

    this.titleService.setTitle(suffix ? `${Constants.APP_NAME} - ${suffix}` : Constants.APP_NAME);
  }
}
